export default class DirectoryEvent {
  constructor(idInDB, contractId, eventDate, eventType, commands, isIntegrationEvent, comments, number, createEventDate, documentDate) {
    this.idInDB = idInDB;
    this.contractId = contractId;
    this.eventDate = eventDate;
    this.createEventDate = createEventDate;
    this.eventType = eventType;
    this.commands = commands;
    this.isIntegrationEvent = isIntegrationEvent;
    this.comments = comments;
    this.number = number;
    this.documentDate = documentDate;
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create DirectoryEvent from data if data is null.");

    return new DirectoryEvent(
      data.idInDB,
      data.contractId,
      data.eventDate,
      data.eventType,
      data.commands,
      data.isIntegrationEvent,
      data.comments,
      data.number,
      data.createEventDate,
      data.documentDate,
    );
  }
}
